document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".countdown").forEach((el) => {
    let t = new Date(el.dataset.endDate.replace(" ", "T")).getTime(),
      d = el.querySelector(".cd-days"),
      h = el.querySelector(".cd-hours"),
      m = el.querySelector(".cd-minutes"),
      s = el.querySelector(".cd-seconds"),
      update = () => {
        let dist = t - Date.now();
        if (dist <= 0) {
          d.textContent = h.textContent = m.textContent = s.textContent = "0";
          return;
        }
        let ds = Math.floor(dist / 864e5),
          hs = Math.floor((dist % 864e5) / 36e5),
          ms = Math.floor((dist % 36e5) / 6e4),
          ss = Math.floor((dist % 6e4) / 1e3);
        d.textContent = ds;
        h.textContent = hs < 10 ? "0" + hs : hs;
        m.textContent = ms < 10 ? "0" + ms : ms;
        s.textContent = ss < 10 ? "0" + ss : ss;
      };
    update();
    setInterval(update, 1e3);
  });

  /*
  let dE = document.getElementById("days"),
    hE = document.getElementById("hours"),
    mE = document.getElementById("minutes"),
    sE = document.getElementById("seconds"),
    dP = parseInt(dE.textContent, 10),
    hP = parseInt(hE.textContent, 10),
    mP = parseInt(mE.textContent, 10),
    sP = parseInt(sE.textContent, 10),
    decrement = () => {
      sP < 1
        ? ((sP = 59),
          mP < 1
            ? ((mP = 59), hP < 1 ? ((hP = 23), dP < 1 ? (dP = 0) : dP--) : hP--)
            : mP--)
        : sP--;
      dE.textContent = dP;
      hE.textContent = hP;
      mE.textContent = mP < 10 ? "0" + mP : mP;
      sE.textContent = sP < 10 ? "0" + sP : sP;
    };
  setInterval(decrement, 1e3);
  */
});
